import trackProductEvent from '../../utils/trackProductEvent';

// this event should fire when a customer clicks on the Style Quiz CTA on the Ungated PDP

// eslint-disable-next-line import/prefer-default-export
export const trackOnboardingCtaClick = (
  selectedSkuId,
  externalProductId,
  clientBusinessLine,
  productBusinessLine,
  skipEventTracking = false,
) => {
  if (skipEventTracking) {
    return;
  }

  const eventName = 'ungated.pdp';
  const canonicalName = 'pdp';
  const actionType = 'click';
  const actionName = 'cta_onboarding';
  const actionDetail = 'ungated_shop';
  const directBuyContext = {
    sku_id: selectedSkuId,
    external_product_id: externalProductId,
    sub_source: null,
    source: 'ungated_shop',
    collection: null,
  };

  const metricsTags = {
    client_business_line: clientBusinessLine,
    product_business_line: productBusinessLine,
    shop_product_model: !!externalProductId,
  };

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
    directBuyContext,
    metricsTags,
  });
};
